<template>
  <div class="tinymce_editor">
    <Editor
      id="tinymce"
      :initial-value="content"
      @onKeyUp="keyUp"
      @onChange="keyUp"
      :init="editorInit"
    />
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce";
import "tinymce/themes/modern/theme";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/plugins/image";
import "tinymce/plugins/media";
import "tinymce/plugins/link";
import "tinymce/plugins/table";
import "tinymce/plugins/code";
import "tinymce/plugins/lists";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/fullscreen";

import * as qiniu from "qiniu-js";

export default {
  components: {
    Editor,
  },
  props: ["tinymceHtml", "changeEdit", "content", "height"],
  data() {
    return {
      editorInit: {
        remove_trailing_brs: false,
        content_style: "p {text-aligin:center;} img { max-width: 100%;height: auto;}",
        paste_enable_default_filters: false,
        height: this.height || "400",
        tinyMCE: null,
        fontsize_formats: "11px 12px 14px 16px 18px 24px 36px 48px",
        font_formats: `
              微软雅黑=微软雅黑;
              宋体=宋体;
              黑体=黑体;
              仿宋=仿宋;
              楷体=楷体;
              隶书=隶书;
              幼圆=幼圆;
              Andale Mono=andale mono,times;
              Arial=arial, helvetica,
              sans-serif;
              Arial Black=arial black, avant garde;
              Book Antiqua=book antiqua,palatino;
              Comic Sans MS=comic sans ms,sans-serif;
              Courier New=courier new,courier;
              Georgia=georgia,palatino;
              Helvetica=helvetica;
              Impact=impact,chicago;
              Symbol=symbol;
              Tahoma=tahoma,arial,helvetica,sans-serif;
              Terminal=terminal,monaco;
              Times New Roman=times new roman,times;
              Trebuchet MS=trebuchet ms,geneva;
              Verdana=verdana,geneva;
              Webdings=webdings;
              Wingdings=wingdings,zapf dingbats`,
        relative_urls: false,
        remove_script_host: false,
        selector: "#tinymce",
        external_plugins: {
          powerpaste:
            "https://file.manamana.net/assets/js/powerpaste/plugin.min.js",
        },
        language_url:
          this.$language() === "zh"
            ? "https://file.manamana.net/assets/js/powerpaste/langs/zh_CN.js"
            : undefined,
        skin_url: "/static/tinymce/skins/lightgray",
        plugins:
          "link lists image table colorpicker textcolor wordcount lineheight contextmenu code media fullscreen",
        toolbar:
          "fullscreen bold italic underline strikethrough | fontsizeselect  lineheightselect fontselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image media code | removeformat",
        branding: false,
        file_picker_types: "media",
        paste_merge_formats: false,
        powerpaste_html_import: "merge",
        media_live_embeds: true,
        paste_remove_styles_if_webkit: false,
        media_filter_html: false,
        valid_classes: "start_1_start end_2_end",
        file_picker_callback: (callback, value, meta) => {
          const input = document.createElement("input");
          input.setAttribute("type", "file");
          if (meta.filetype == "media") {
            input.setAttribute("accept", "video/*");
            input.onchange = () => {
              var file = input.files[0];
              this.upVideo(file, callback);
            };
          }
          input.click();
        },
        images_upload_handler: (blobInfo, success, failure) => {
          let $this = this;
          // if (!/blobid(\d+).gif/.test(blobInfo.filename())) {
          //   console.log(222)
          //   let imgFile = blobInfo.blob();
          //   var observable;
          //   var subscription;
          //   var error = function (err) {
          //     $this.uploadMessage = $this.$t("global.上传失败");
          //   };
          //   var complete = function (res) {
          //     console.log(res)
          //     success("https://image.manamana.net/" + res.key);
          //   };

          //   var next = function (response) {};

          //   var subObject = {
          //     next: next,
          //     error: error,
          //     complete: complete,
          //   };

          //   var config = {
          //     useCdnDomain: true,
          //     region: null,
          //     domain: "https://image.manamana.net",
          //     forceDirect: true,
          //   };
          //   var putExtra = {
          //     fname: imgFile.name,
          //     params: {},
          //     mimeType: null,
          //   };
          //   this.$http.get("/api/common/upload/image/token").then((res) => {
          //     observable = qiniu.upload(
          //       imgFile,
          //       Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          //       res.message,
          //       putExtra,
          //       config
          //     );
          //     subscription = observable.subscribe(subObject);
          //   });
          // }
          let imgFile = blobInfo.blob();
          var observable;
          var subscription;
          var error = function (err) {
            $this.uploadMessage = $this.$t("global.上传失败");
          };
          if (imgFile.size / 1024 / 1024 > 20) {
              failure(`${this.$t("global.上传图片大小不能超过")} 20MB!`)                      
          } 
          var complete = function (res) {
            success("https://image.manamana.net/" + res.key);
          };

          var next = function (response) {};

          var subObject = {
            next: next,
            error: error,
            complete: complete,
          };

          var config = {
            useCdnDomain: true,
            region: null,
            domain: "https://image.manamana.net",
            forceDirect: true,
          };
          var putExtra = {
            fname: imgFile.name,
            params: {},
            mimeType: null,
          };
          this.$http.get("/api/common/upload/image/token").then((res) => {
            observable = qiniu.upload(
              imgFile,
              Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
              res.message,
              putExtra,
              config
            );
            subscription = observable.subscribe(subObject);
          });
        },
        paste_preprocess: (plugin, args) => {
          const innerHTML = args.content;
          const list = [];
          let _num = 0;
          const text = innerHTML.replace(/<img[^>]*>/g, (a) => {
            let src,
              key = Date.now() + (Math.random() * 1000).toFixed(0) + _num;
            _num++;
            let _width;
            a.replace(/ _width="([^"]*)"/, (b, c) => {
              if (/%/.test(c)) {
                _width = c;
              } else {
                _width = "100%";
              }
            });
            return a
              .replace(/style="([^"]*)"/, "")
              .replace(/ src="([^"]*)"/, (b, c) => {
                src = c;
                if (
                  c.indexOf("http://image.manamana.net/") === -1 &&
                  c.indexOf("https://image.manamana.net/") === -1
                ) {
                  if (a.includes("data-src=")) {
                    a.replace(/data-src="([^"]*)"/, (d, e) => {
                      src = e;
                    });
                  }
                  if (
                    src.indexOf("http") !== -1 &&
                    src.indexOf("blob:") === -1
                  ) {
                    list.push({
                      key: key,
                      url: src.includes("https://mmbiz.qpic.cn")
                        ? src.split("?")[0]
                        : src,
                    });
                  }
                  return ` src="https://image.manamana.net/${key}?imageView2/2/format/gif" onerror="parent&&parent.reloadImg(this,5)" style="width:${
                    _width || "100%"
                  }"`;
                } else {
                  return ` src=${c} style="width:${_width}"`;
                }
              });
          });
          setTimeout(() => {
            if (list.length > 0) {
              this.$http
                .post("/api/common/fetch/images", {
                  list: JSON.stringify(list),
                })
                .then((res) => {
                  let content = tinymce.get("tinymce").getContent();
                  content = content
                    .replace(/\n/g, "")
                    .replace(
                      /<p class="start_1_start">.*<p class="end_2_end">[^<]*<\/p>/,
                      text
                    );
                  tinymce.get("tinymce").setContent(content);
                  this.changeContent(content);
                });
            }
          }, 1000);
          setTimeout(()=>{
            if (list.length == 0) {
              this.$emit("changeEdit", tinymce.get("tinymce").getContent());
            }
          },3000)
          args.content = `<p class="start_1_start"></p> ${innerHTML} <p class="end_2_end"></p>`;
        },
        paste_postprocess: function (editor, args) {

        },
        video_template_callback: function (data) {
          return `<video width="100%" height="auto" poster="${
            data.source1.includes("?")
              ? data.source1 + "&vframe/jpg/offset/1/w/750"
              : data.source1 + "?vframe/jpg/offset/1/w/750"
          }" controls="controls"><source src=${data.source1} ${
            data.source1mime ? ' type="' + data.source1mime + '"' : ""
          } /></video>`;
        },
        media_url_resolver: function (data, resolve) {
          resolve({
            html: `<iframe
              src=${data.url}
              frameborder="0"
              allowfullscreen
              scrolling="no"
              style="max-width:100%;width:730px;height:410px;"
            ></iframe>`,
          });
        },
      },
    };
  },
  created() {
    this.addLineHeight(tinymce);
    window.reloadImg = this.reloadImg;
  },
  mounted() {
    const tinyInit = {
      selector: "tinymce",
      force_p_newlines: true,
    };
    this.tinyMCE = tinymce.init(tinyInit);
  },
  methods: {
    addLineHeight(tinymce) {
      tinymce.PluginManager.add("lineheight", function (editor, url, $) {
        editor.on("init", function () {
          editor.formatter.register({
            lineheight: { inline: "span", styles: { "line-height": "%value" } },
          });
        });

        editor.addButton("lineheightselect", function () {
          var items = [],
            defaultLineHeightFormats = "1.2em 1.4em 1.6em 1.8em 2em";
          var lineheight_formats =
            editor.settings.lineheight_formats || defaultLineHeightFormats;
          lineheight_formats.split(" ").forEach(function (item) {
            var text = item,
              value = item;
            // Allow text=value for line-height formats
            var values = item.split("=");
            if (values.length > 1) {
              text = values[0];
              value = values[1];
            }
            items.push({ text: text, value: value });
          });
          return {
            type: "listbox",
            text: "Line Height",
            tooltip: "Line Height",
            values: items,
            fixedWidth: true,
            onPostRender: function () {
              var self = this;
              editor.on("nodeChange", function (e) {
                var formatName = "lineheight";
                var formatter = editor.formatter;
                var value = null;
                e.parents.forEach(function (node) {
                  items.forEach(function (item) {
                    if (formatName) {
                      if (
                        formatter.matchNode(node, formatName, {
                          value: item.value,
                        })
                      ) {
                        value = item.value;
                      }
                    } else {
                      if (formatter.matchNode(node, item.value)) {
                        value = item.value;
                      }
                    }
                    if (value) {
                      return false;
                    }
                  });
                  if (value) {
                    return false;
                  }
                });
                self.value(value);
              });
            },
            onselect: function (e) {
              tinymce.activeEditor.formatter.apply("lineheight", {
                value: this.value(),
              });
            },
          };
        });
      });
      tinymce.PluginManager.requireLangPack("lineheight", "de");
    },
    upVideo(file, callback) {
      const fileName = file.name;
      const type = file.type;
      if (file.size / 1024 / 1024 > 3072) {
        this.$message.info(this.$t(`global.文件不能大于3G`) + `!`);
        return;
      }
      var observable;
      var subscription;
      var error = (err) => {
        console.log(err);
      };
      var complete = (res) => {
        callback("https://video.manamana.net/" + res.key);
      };
      var next = (res) => {};
      var subObject = {
        next: next,
        error: error,
        complete: complete,
      };
      var config = {
        useCdnDomain: true,
        disableStatisticsReport: false,
        retryCount: 3,
        region: null,
      };
      var putExtra = {
        fname: fileName.split(".")[0],
        params: {},
        mimeType: null,
      };
      this.$http.get("/api/common/upload/token/video").then((res) => {
        this.token = res.data;
        observable = qiniu.upload(
          file,
          Date.parse(new Date()) + "_" + fileName,
          this.token,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
    },
    reloadImg(e, num) {
      const src = e.src;
      if (num) {
        e.onerror = () => {
          setTimeout(() => {
            this.reloadImg(e, num - 1);
          }, 3000);
        };
        e.src = src;
      } else {
        e.onerror = null;
        e.src = "";
      }
    },
    keyUp(a, b, c) {
      const content = b.getContent();
      this.$emit("changeEdit", content);
    },
    changeContent(content) {
      this.$emit("changeEdit", content);
    },
  },
  updated() {
    if (this.content !== tinymce.get("tinymce").getContent()) {
      tinymce.get("tinymce").setContent(this.content);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/editor/Editor.vue